module.exports = __webpack_public_path__ + "img/loader-green.8a052d0c.svg";